import { compactNumber } from '@/utilities/Number';
import { LabelValue } from '@/types/label-value';

const MAX_SLICES = 5;

export interface Doughnut2DFusionChartConfig {
  animation?: string;
  theme?: string;
  showLegend?: boolean;
  forceYAxisValueDecimals?: boolean;
  decimals?: number;
  caption?: string;
  captionFontSize?: number;
  xAxisName?: string;
  yAxisName?: string;
  exportFilename?: string;
  paletteColors?: string[];
  defaultCenterLabel?: string;
  centerLabel?: string;
  captionAlignment?: string;
  centerLabelFontSize?: number;
  chartLeftMargin?: number;
  chartRightMargin?: number;
  chartTopMargin?: number;
  chartBottomMargin?: number;
  showBorder?: boolean;
  width?: number;
  height?: number;
  doughnutRadius?: string;
}

export interface FusionChartDoughnut2D extends Partial<Doughnut> {
  chart: Doughnut2DFusionChartConfig;
}

export interface Doughnut {
  data : DoughnutData[];
}

export interface DoughnutData {
  label?: string,
  value: number,
  displayValue?: string,
  toolText?: string,
}

function defaultCompactFunction(d: LabelValue): DoughnutData {
  const displayValue = compactNumber(d.value, { minimumFractionDigits: 0, maximumFractionDigits: (d.value ?? 0) < 1_000_000 ? 0 : 1 });

  return {
    ...d,
    displayValue: displayValue
  };
}

export async function compactDisplayValueForDoughnutChart(ms: Promise<LabelValue[]>, compactFunction = defaultCompactFunction): Promise<DoughnutData[]> {
  return ms.then(d => d ? d.map(e => compactFunction(e)) : []);
}

export function formatDoughnutChartData(data: DoughnutData[]): DoughnutData[] {
  const sortedData = data.sort((a,b) => b.value - a.value);

  if(sortedData.length > MAX_SLICES){
    const otherData = sortedData.slice(MAX_SLICES);
    const otherValue = otherData.reduce((acc, r) => acc + r.value, 0);
    const otherToolTip = otherData.reduce((acc, r) => acc + `<b>${r.label}</b>: ${compactNumber(r.value)}<br>`,'')

    return [...sortedData.slice(0,MAX_SLICES), {...defaultCompactFunction({label: 'Other', value: otherValue}), toolText: otherToolTip}]
  }

  return sortedData;
}
